import {useState, useCallback} from 'react';
import {udExpiringLocalStorage} from '@udemy-v2/utils';

const browserStore = udExpiringLocalStorage('frontends-course-landing-page', 'review-helpfulness');

export function makeStorageKey(reviewId: number): string {
    return `udemy/review/${reviewId}/helpfulness`;
}

export interface UseHelpfulnessProps {
    reviewId: number;
    viewPosition: number;
    courseId: number;
    page: number;
    filterState: {rating: number | null; term: string | null};
    store?: typeof browserStore;
}

export function useHelpfulness({
    reviewId,
    viewPosition,
    courseId,
    page,
    filterState,
    store = browserStore,
}: UseHelpfulnessProps) {
    const [value, setValue] = useState<boolean | null>(
        () => (store.get(makeStorageKey(reviewId)) ?? null) as boolean | null,
    );

    const onToggle = useCallback(
        (newValue: boolean) => {
            if (newValue === value) {
                store.delete(makeStorageKey(reviewId));
                setValue(null);
            } else {
                store.set(makeStorageKey(reviewId), newValue);
                setValue(newValue);
            }
        },
        [reviewId, value, store],
    );

    return {
        value,
        onToggle,
        reviewId,
        viewPosition,
        courseId,
        page,
        filterState,
    };
}
